import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from "react-bootstrap-table2-paginator";
import { Grid, useTheme } from "@material-ui/core";
import overlayFactory from "react-bootstrap-table2-overlay";
import { useTranslation } from 'react-i18next';

const DesktopTable = ({
    data,
    columns,
    page,
    sizePerPage,
    onTableChange,
    totalSize,
    title,
    showPagination,
    rowHeight,
    keyField,
    className,
    noTitle,
    overflowScroll,
    hideBorderTop,
    sizePerPageList,
    props
}) => {
    const { t } = useTranslation();
    const { direction } = useTheme();
    const options = {
        custom: true,
        page,
        sizePerPage,
        totalSize,
        sizePerPageList: sizePerPageList,
    };
    const indication = () => {
        return (
            <div className="empty">
                <p>{t('noData2Display')}</p>
            </div>
        );
    };
    const rowStyle = () => {
        return {
            borderRight: "none",
            borderLeft: "none",
            borderBottom: "none",
            borderTop: "none",
            height: rowHeight,
            padding: "0px",
            maxHeight: rowHeight,
            minHeight: rowHeight,
            overflow: "hidden",
            // borderTop: "1px solid #a8b4bb",
            // borderBottom: "1px solid #a8b4bb",
            // backgroundColorOdd: "",
        };
    };
    return (
        <div className="desktop-mode">
            <PaginationProvider pagination={paginationFactory(options)}>
            {
                ({ paginationProps, paginationTableProps }) => (
                    <div className={`remoteTable ${direction} ${className}`}>
                        {/* {
                            !noTitle &&
                            <Grid item xs={12}>
                                <p className={`table-title ${hideBorderTop ? 'hideBorderTop' : ''}`}>
                                    {title}
                                </p>
                            </Grid>
                        } */}
                        <div className={overflowScroll && "tblOverflowScroll"}>
                            <BootstrapTable
                                remote
                                keyField={keyField}
                                striped
                                hover
                                // bordered
                                classes="table"
                                headerClasses="header"
                                defaultSortDirection="asc"
                                data={data}
                                columns={columns}
                                noDataIndication={indication}
                                rowStyle={rowStyle}
                                onTableChange={onTableChange}
                                overlay={overlayFactory({
                                    spinner: true,
                                    styles: {
                                        overlay: (base) => ({ ...base, background: "rgba(65, 166, 156, 0.1)" }),
                                    },
                                })}
                                {...paginationTableProps}
                                {...props}
                            />
                        </div>
                        {
                            (showPagination && data.length !== 0 && ((totalSize / sizePerPage) > 1)) && 
                            <Grid container justifyContent="center" className="mb-1">
                                <PaginationListStandalone {...paginationProps} />
                                <SizePerPageDropdownStandalone {...paginationProps} />
                            </Grid>
                        }
                    </div>
                )}
            </PaginationProvider>
        </div>
    );
};

export default DesktopTable;